import { CustomerAttribute } from '@common/customerAttributes/types';
import { AuthState } from '@src/store/auth';
import type { ConfigState } from '@src/store/config';
import { ApiLoadConsentResponse, ConsentSaveType } from '@src/types/common';
import { getTracingHeaders } from '@src/util/helpers';
import { checkScenario } from '@src/util/scenario';
import { HttpClient } from './HttpClient';

export abstract class ClientAbstract {
  protected httpClient: HttpClient;

  protected config: ConfigState;

  protected auth: AuthState;

  constructor(config: ConfigState, auth: AuthState) {
    const {
      apiUri, accessToken: configAccessToken, customerToken, traceid,
    } = config;
    const { accessToken: comsInternalAccessToken } = auth;

    const { isRaittNoTokensWithInterception, isAuthOverride } = checkScenario(config);

    const headers: Record<string, string> = {
      Accept: 'application/json; charset=utf-8',
      ...getTracingHeaders(traceid),
    };

    if (!isRaittNoTokensWithInterception) {
      headers.Authorization = configAccessToken
        ? `Bearer ${configAccessToken}`
        : `Access ${comsInternalAccessToken}`;
    }

    if (isAuthOverride) {
      headers['x-authorization-override'] = customerToken
        ? `Customer ${customerToken}`
        : `Access ${comsInternalAccessToken}`;
    }

    this.httpClient = new HttpClient(apiUri, headers);
    this.config = config;
    this.auth = auth;
  }

  abstract getConsents(lifecycle: string): Promise<ApiLoadConsentResponse>;
  abstract saveConsents(data: ConsentSaveType[], customerAttributeData: CustomerAttribute[]): Promise<void>;

  getCustomerInfoFromConfigOrAuth(): { lcId?: string, registerId?: string, spId: string } {
    const source = this.auth.spId
      ? this.auth // take details from `GET /token` or `GET /userprofile`
      : this.config; // take details from MF configuration
    return {
      spId: source.spId!,
      lcId: source.lcId,
      registerId: source.registerId,
    };
  }
}
